// 埋点用法
// 全局引入TalkingData.js 和 td-h5-website-sdk.js


//埋点功能

//页面埋点
export function pageBuryingPoint(name){ //p_dsyxskx_01
  let isTrackData=true;
 // 页面初始化
  var ua = navigator.userAgent.toLowerCase();
  if (ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1) {
    location.href = 'KDS_Native://getTDDataTrackingFlag';
  } else if (ua.indexOf('android') > -1) {
    window.KDS_Native.getTDDataTrackingFlag();
  }

  window.setTDDataTrackingFlag=function (isTrackData) {
    if(isTrackData == '0'){
      localStorage.removeItem('isTrackData');
    }else{
      localStorage.setItem('isTrackData',true);
      if (name) {
        TalkingData.onPageBegin(name);
      }
    }
  }
}

//事件埋点
export function eventBuryingPoint(totalEventName,sonEventName){ //"c_ytwxyx_01"，l_ytwxfxjeljcj_01
    // totalEventName: 总事件名称  sonEventName：子事件名称
  if (localStorage.getItem('isTrackData')) {
    TalkingData.onEventWithLabel(totalEventName, sonEventName);
  }
}



//销毁埋点
export function DestructyBuryingPoint(name) {
  // 页面销毁
  window.onbeforeunload = function(){
    if(localStorage.getItem('isTrackData')){
      TalkingData.onPageEnd(name);
    }
  }
}


// module.exports={
//   pageBuryingPoint,
//   eventBuryingPoint,
//   DestructyBuryingPoint
// }
